import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=e60c509a&scoped=true&"
import script from "./MenuIcon.vue?vue&type=script&lang=js&"
export * from "./MenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=e60c509a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c509a",
  null
  
)

export default component.exports